import ImgKembaliBerjumpa from '@assets/images/p-kembali-berjumpa.jpg';
import ImgJakartaKroasia from '@assets/images/p-jakarta-kroasia.jpg';
import ImgBoarding from '@assets/images/p-boarding-smg.jpg';
import ImgKembaliKeIndonesia from '@assets/images/p-kembali-ke-indonesia.jpg';
import ImgNdodokLawang from '@assets/images/p-ndodok-lawang.jpg';

export const stories = [
  {
    title: 'Jumpa Pertama',
    date: '18 Desember 2019',
    description:
      'Pertama kali mereka dipertemukan di toko besi t. Pada saat itu Mei sedang berkunjung ke toko besi t. Pertemuan pertama ini, mereka masih merasa biasa saja, hanya sebagai rekan kerja.',
    image: '',
  },
  {
    title: 'Kembali Berjumpa',
    date: '8 Februari 2020',
    description:
      'Saat itu Faisal sedang melakukan tugas untuk perbaikan komputer seluruh kantor cabang, termasuk kantor cabang yang dimana Mei bekerja. Ketika mereka bertemu kembali, Mei selalu bercanda dengan cara merayu Faisal yang sedang bekerja. faisal merasa tidak nyaman ketika dirayu Mei. Perasaan mereka pada saat itu juga masih biasa saja.',
    image: '',
  },
  {
    title: 'Kisah Perjalanan Cinta',
    date: 'Maret 2020',
    description:
      'Dimoment lain, mereka sempat bertemu kembali untuk menghadiri acara pernikahan. Dimana pada saat pertemuan mereka, rekan-rekan kerja melihat dan merasa penasaran atas kebersamaan mereka diacara pernikahan tersebut, karena sebelumnya mereka tidak pernah bersama. Sehingga rekan-rekan kerja mulai menyanding-nyandingkan mereka berdua. Sejak saat itu, mereka mulai sering komunikasi. Dan mereka mulai tertarik satu sama lain. Hingga akhirnya mereka berkomitmen untuk menjalin hubungan dengan serius pada tanggal 15 Maret 2020.',
    image: '',
  },
  {
    title: 'Ndodok Lawang',
    date: '9 Januari 2022',
    description:
      'Akhirnya tiba di masa Faisal dan keluarga hadir ke rumah Mei untuk menyampaikan niat baik. Mulai dari acara Ndodok Lawang ini, dilanjutkan dengan persiapan pernikahan yang insha Allah akan diselenggarakan pada tanggal 8 Juli 2022.',
    image: '',
  },
];
